/**
 * Data access for the user entity (``GET /api/me/``).
 *
 * Read-only; the profile and balance are server-authoritative. Returns the shared
 * query state so callers can render loading/error/auth-gate states.
 */
import { useApiQuery, type QueryState } from "@shared/api";

import type { Me } from "./model";

/** Path of the current-user endpoint. */
export const ME_PATH = "/me/";

/** Fetch the authenticated user's profile + balance. */
export function useMe(): QueryState<Me> {
  return useApiQuery<Me>(ME_PATH);
}
